'use client';

import { c as _c } from "react/compiler-runtime";
import { useCouponId, useCouponPrice, useCouponType } from '@svs/nova-poolbetting/core/nextjs/coupon';
import type { CouponIndex } from '@svs/nova-poolbetting/schema/coupon';
import { CouponRowHeader, DeleteCouponButton } from '@svs/nova-poolbetting/ui/Coupon';
import { cn } from '@svs/nova-poolbetting/ui/utils';
import type { ReactNode } from 'react';

/**
 * Component that renders the header for each coupon row.
 *
 * @param root0 props for the component
 * @param root0.couponIndex index of the coupon to render
 * @param root0.className additional class names to apply
 * @param root0.isSelectedCouponIndex indicates if the coupon index is the currently selected one to apply delete button
 * @returns component that renders the header for each coupon row
 */
export function CouponRowHeaderContainer(t0) {
  const $ = _c(20);
  const {
    couponIndex,
    className,
    isSelectedCouponIndex
  } = t0;
  const [couponId] = useCouponId();
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex) {
    t1 = {
      couponId,
      couponIndex
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const price = useCouponPrice(t1);
  let t2;
  if ($[3] !== couponId || $[4] !== couponIndex) {
    t2 = {
      couponId,
      couponIndex
    };
    $[3] = couponId;
    $[4] = couponIndex;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const couponType = useCouponType(t2);
  const isSingleRows = couponType === "singlerows";
  const systemText = isSingleRows ? `Rad ${couponIndex + 1}` : `Kupong ${couponIndex + 1}`;
  const t3 = `flex max-h-15 min-h-15 items-center justify-between p-2 ${className}`;
  let t4;
  if ($[6] !== t3) {
    t4 = cn(t3);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !isSingleRows;
  let t6;
  if ($[8] !== isSelectedCouponIndex || $[9] !== price || $[10] !== systemText || $[11] !== t5) {
    t6 = <CouponRowHeader systemText={systemText} price={price} shouldShowPrice={t5} isSelectedCouponIndex={isSelectedCouponIndex} />;
    $[8] = isSelectedCouponIndex;
    $[9] = price;
    $[10] = systemText;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== couponIndex || $[14] !== isSelectedCouponIndex) {
    t7 = isSelectedCouponIndex && <DeleteCouponButton couponIndex={couponIndex} />;
    $[13] = couponIndex;
    $[14] = isSelectedCouponIndex;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t6 || $[18] !== t7) {
    t8 = <div data-style-element={true} className={t4}>{t6}{t7}</div>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}